exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.send-vercode-btn[data-v-b02b08e8]{display:inline-block;width:21.33333vw;font-size:3.73333vw;border:0;color:#4f8df7;background:transparent\n}\n.theme-2[data-v-b02b08e8]{display:inline-block;border-radius:3.73333vw;background:#5d80ed;width:21.33333vw;height:7.46667vw;line-height:8vw;text-align:center;font-size:3.2vw;color:#ffffff;font-family:fzlt\n}\n.theme-2.android[data-v-b02b08e8]{line-height:8.26667vw\n}\n.theme-2.disabled[data-v-b02b08e8]{background:#b2bac9\n}\n", ""]);

// exports
